<template>
    <div class="serial-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Tryout Serial', to: { path: '/serial' }, exact: true },
                { text: 'Tambah Tryout Serial' },
            ]"
            divider="|"
        ></v-breadcrumbs>
        <!-- begin page-header -->
        <h3 class="header-text font-weight-bold">
            {{ id == null ? "Tambah" : "Ubah" }} Tryout Serial
        </h3>

        <v-card plain class="pa-4">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Judul *
                    </v-list-item-title>
                    <v-text-field
                        placeholder="Judul Tryout Serial"
                        v-model="title"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Deskripsi
                    </v-list-item-title>
                    <v-textarea
                        placeholder="Deskripsi Tryout Serial"
                        v-model="description"
                        outlined
                    />
                </v-list-item-content>
            </v-list-item>
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        Kelas
                    </v-list-item-title>

                    <v-select
                        outlined
                        placeholder="Pilih Kelas"
                        v-model="grade"
                        class="pa-0"
                        :items="[
                            { text: '1 (SD)', value: 1 },
                            { text: '2 (SD)', value: 2 },
                            { text: '3 (SD)', value: 3 },
                            { text: '4 (SD)', value: 4 },
                            { text: '5 (SD)', value: 5 },
                            { text: '6 (SD)', value: 6 },
                            { text: '7 (SMP)', value: 7 },
                            { text: '8 (SMP)', value: 8 },
                            { text: '9 (SMP)', value: 9 },
                            { text: '10 (SMA)', value: 10 },
                            { text: '11 (SMA)', value: 11 },
                            { text: '12 (SMA)', value: 12 },
                        ]"
                    ></v-select>
                </v-list-item-content>
            </v-list-item>

            <v-card flat class="px-0 pt-0 mt-3 ma-0 pb-8" v-if="id != null">
                <v-card-title class="pa-0 text-subtitle-1 font-weight-bold">
                    Serial
                </v-card-title>
                <v-card
                    outlined
                    class="my-3"
                    v-for="group in groups"
                    v-bind:key="group.series_sequence"
                >
                    <v-list class="pa-0 text-subtitle-2">
                        <template>
                            <v-list-item two-line>
                                <v-list-item-content
                                    class="mx-2 my-0 align-self-start"
                                    style="max-width: 10%"
                                >
                                    <v-list-item-subtitle
                                        class="font-weight-bold"
                                    >
                                        Group ID
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        style="
                                            text-overflow: unset;
                                            white-space: unset;
                                        "
                                    >
                                        {{ group.id }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-content
                                    class="mx-2 my-0 align-self-start"
                                >
                                    <v-list-item-subtitle
                                        class="font-weight-bold"
                                    >
                                        Tryout Group
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        {{ group.name }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn
                                        plain
                                        class="pa-0"
                                        @click="confirmUnAttachGroup(group)"
                                    >
                                        <span
                                            class="red--text"
                                            :class="
                                                $vuetify.breakpoint.mdAndUp
                                                    ? 'font-weight-700'
                                                    : 'font-weight-600'
                                            "
                                            :style="
                                                $vuetify.breakpoint.smAndDown
                                                    ? 'font-size: 12px'
                                                    : ''
                                            "
                                            >Hapus</span
                                        >
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </template>
                    </v-list>
                </v-card>

                <app-tryoutgroupchooser
                    v-on:dblClicked="onGroupSelected($event)"
                    :params="{ grade: grade, attached: false }"
                ></app-tryoutgroupchooser>
            </v-card>
            <v-divider></v-divider>
            <v-card-actions class="py-2">
                <v-spacer></v-spacer>

                <v-btn color="primary" @click="save()"> Simpan </v-btn>
            </v-card-actions>
        </v-card>
        <app-spinner v-if="isLoading"></app-spinner>

        <v-dialog
            v-if="showUnAttachModal"
            v-model="showUnAttachModal"
            persistent
            max-width="506px"
        >
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    Hapus Tryout Group
                </v-card-title>
                <v-card-text>
                    Apakah anda yakin akan menghapus Tryout Group
                    <strong class="text-danger">{{
                        selectedGroup.name
                    }}</strong>
                    pada Serial
                    <strong class="text-danger">{{ title }}</strong> ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="showUnAttachModal = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn color="blew" text @click="processUnAttachGroup()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Modal from "@/modules/global/components/plugins/Modal";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutGroupChooser from "@/modules/tryout_group/components/TryoutGroupChooser";
import TryoutService from "@/modules/tryout/services/tryout.js";

export default {
    name: "serial-form",

    components: {
        "app-modal": Modal,
        "app-spinner": Spinner,
        "app-tryoutgroupchooser": TryoutGroupChooser,
    },

    data: function () {
        return {
            id: null,
            title: null,
            description: null,
            grade: 12,
            isLoading: false,
            errors: [],
            groups: [],
            stack: [],
            showUnAttachModal: false,
            selectedGroup: null,
        };
    },

    methods: {
        validateForm: function () {
            var error = false;
            this.title = this.title.trim();

            if (!this.title || this.title == " ") {
                this.$store.commit("showAlert", {
                    message: `Judul Tryout!`,
                    submessage: `Judul wajib diisi!`,
                    type: "error",
                });
                var error = true;
            }
            return !error;
        },

        save: function () {
            var context = this;
            this.isLoading = true;
            if (this.validateForm()) {
                var data = {
                    title: this.title,
                    description: this.description,
                    grade: this.grade,
                };

                if (this.$route.query.id) {
                    data.id = this.$route.query.id;
                    TryoutService.editTryoutSeries(data, function (response) {
                        if (response.success) {
                            context.id = response.data.id;
                            context.title = response.data.title;
                            context.description = response.data.description;
                            context.grade = response.data.grade;
                            context.$store.commit("showAlert", {
                                message: `Tryout telah berhasil diubah!`,
                                type: "success",
                            });
                            context.$router.push("/serial");
                        }

                        context.isLoading = false;
                    });
                } else {
                    TryoutService.createTryoutSeries(data, function (response) {
                        if (response.success) {
                            context.id = response.data.id;
                            context.title = response.data.title;
                            context.description = response.data.description;
                            context.grade = response.data.grade;
                            context.$store.commit("showAlert", {
                                message: `Tryout telah berhasil ditambahkan!`,
                                type: "success",
                            });
                            context.$router.push("/serial");
                        }

                        context.isLoading = false;
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        onGroupSelected: function (group) {
            this.getGroupDetail(group.id);
        },

        getGroupDetail: function (groupId) {
            this.isLoading = true;
            var context = this;

            TryoutService.getTryoutGroup(groupId, function (response) {
                if (response.success) {
                    context.stack.push(response.data);

                    if (response.data.dependency_id === null)
                        context.processAttachGroups();
                    else context.getGroupDetail(response.data.dependency_id);
                }

                context.isLoading = false;
            });
        },

        processAttachGroups: function () {
            if (this.stack.length == 0) {
                this.getListOfAttachedGroups();
            } else {
                this.isLoading = true;

                var context = this;
                var group = this.stack.pop();
                TryoutService.attachGroupIntoSeries(
                    group.id,
                    this.id,
                    function (response) {
                        if (response.success) {
                            context.isLoading = false;
                            context.processAttachGroups();
                        } else {
                            this.isLoading = false;
                        }
                    },
                );
            }
        },

        confirmUnAttachGroup: function (group) {
            this.selectedGroup = group;
            this.showUnAttachModal = true;
        },

        processUnAttachGroup: function () {
            var found = this.groups.find(
                (g) => g.dependency_id === this.selectedGroup.id,
            );

            if (found) {
                var message =
                    "Tidak dapat menghapus group dikarenakan menjadi prasyarat: " +
                    found.name;
                this.$store.commit("showAlert", {
                    message: message,
                    type: "error",
                });
                this.$store.commit("error_show", message);
                this.showUnAttachModal = false;
            } else {
                var context = this;
                var groupId = this.selectedGroup.id;
                var seriesId = this.id;

                this.isLoading = true;
                TryoutService.dettachGroupFromSeries(
                    groupId,
                    seriesId,
                    function (response) {
                        if (response.success) {
                            context.groups = [];
                            var params = { series_id: context.id };
                            TryoutService.getListOfTryoutGroups(
                                null,
                                null,
                                params,
                                function (response) {
                                    if (response.success) {
                                        response.data.tryout_groups.forEach(
                                            function (group) {
                                                context.groups.push(group);
                                            },
                                        );

                                        context.groups.sort(function (a, b) {
                                            return (
                                                a.series_sequence -
                                                b.series_sequence
                                            );
                                        });
                                    }

                                    context.isLoading = false;
                                    context.showUnAttachModal = false;
                                },
                                context.grade,
                                context.id,
                            );
                        }
                    },
                );
            }
        },

        getListOfAttachedGroups: function () {
            var context = this;
            var params = { series_id: this.id };
            TryoutService.getListOfTryoutGroups(
                null,
                null,
                params,
                function (response) {
                    if (response.success) {
                        context.groups = [];
                        response.data.tryout_groups.forEach(function (group) {
                            context.groups.push(group);
                        });

                        context.groups.sort(function (a, b) {
                            return a.series_sequence - b.series_sequence;
                        });
                    }
                },
                context.grade,
                context.id,
            );
        },
    },

    mounted: function () {
        var context = this;
        var seriesId = this.$route.query.id;
        if (this.$route.query.id) {
            this.isLoading = true;
            TryoutService.getTryoutSeries(seriesId, function (response) {
                if (response.success) {
                    context.id = response.data.id;
                    context.title = response.data.title;
                    context.description = response.data.description;
                    context.grade = response.data.grade;
                    context.getListOfAttachedGroups();
                }

                context.isLoading = false;
            });
        } else {
            this.isLoading = false;
        }
    },
};
</script>



// WEBPACK FOOTER //
// Form.vue?daddfa9e